import React from 'react';
import PublicLayout from './PublicLayout';

export default function LandingPage() {
  return (
    <PublicLayout>
      <section className="landing-hero" aria-labelledby="landing-title">
        <div className="landing-copy">
          <p className="public-eyebrow"><span /> NOTREEN / ЛИЧНОЕ ПРОСТРАНСТВО</p>
          <h1 id="landing-title">Хорошо, когда<br />все <em>свои.</em></h1>
          <p className="landing-description">Небольшое пространство для друзей и знакомых. Входите в личный кабинет — здесь вас знают.</p>
          <a className="public-primary-button" href="/login">Войти в пространство <span aria-hidden="true">↗</span></a>
          <a className="landing-how-link" href="#how-it-works">Как попасть внутрь <span aria-hidden="true">↓</span></a>
        </div>
        <div className="landing-art" aria-hidden="true">
          <span className="art-caption">СВОЙ КРУГ</span>
          <div className="art-orbit art-orbit-one" /><div className="art-orbit art-orbit-two" /><div className="art-orbit art-orbit-three" />
          <div className="art-center"><img src="/logo.svg" alt="" /></div>
          <span className="art-point art-point-one" /><span className="art-point art-point-two" />
          <span className="art-bottom">Знакомые люди.<br />Общее пространство.</span><span className="art-index">N / 01</span>
        </div>
      </section>
      <section className="landing-guide" id="how-it-works" aria-labelledby="guide-title">
        <div className="guide-heading"><p className="public-eyebrow">БЕЗ ЛИШНИХ ШАГОВ</p><h2 id="guide-title">Уже знакомы?<br />Заходите.</h2></div>
        <ol className="guide-steps">
          <li><span className="guide-number">01</span><h3>Откройте бота</h3><p>Ссылка на нашего Telegram-бота есть на странице входа.</p></li>
          <li><span className="guide-number">02</span><h3>Получите код</h3><p>Нажмите «Получить код» и ответьте на вопрос бота.</p></li>
          <li><span className="guide-number">03</span><h3>Вы на месте</h3><p>Введите шесть цифр на сайте, чтобы открыть личный кабинет.</p></li>
        </ol>
      </section>
    </PublicLayout>
  );
}
